var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96139(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-96-139-1{fill:none;}.cls-96-139-2,.cls-96-139-3{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}.cls-96-139-2{stroke:#6e6e6e;}.cls-96-139-3{stroke:#f15c00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "taustavalko"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-96-139-1",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-96-139-2",
    d: "M48.83,31.81A16.1,16.1,0,0,0,32.76,47.89a15.84,15.84,0,0,0,5,11.6,1.71,1.71,0,0,1,.43,1v.81a6.11,6.11,0,0,0,3,5.26h.08v4.67a7.53,7.53,0,0,0,7.56,7.51H49a7.52,7.52,0,0,0,7.55-7.5h0v-4.6a.14.14,0,0,0,.09,0,6.1,6.1,0,0,0,2.94-5.26v-.81a1.69,1.69,0,0,1,.42-1,15.9,15.9,0,0,0,5-11.62A16.1,16.1,0,0,0,49,31.81Zm-7.2,35H56.18M42.26,73.56H55.47M41.17,70.2H56.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96-139-3",
    x1: 33.52,
    y1: 62.75,
    x2: 27.49,
    y2: 68.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96-139-3",
    x1: 27.18,
    y1: 47.44,
    x2: 18.64,
    y2: 47.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96-139-3",
    x1: 33.52,
    y1: 32.12,
    x2: 27.48,
    y2: 26.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96-139-3",
    x1: 48.83,
    y1: 25.78,
    x2: 48.83,
    y2: 17.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96-139-3",
    x1: 64.15,
    y1: 32.12,
    x2: 70.18,
    y2: 26.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96-139-3",
    x1: 70.49,
    y1: 47.44,
    x2: 79.03,
    y2: 47.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96-139-3",
    x1: 64.18,
    y1: 62.75,
    x2: 70.18,
    y2: 68.79
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96139);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_139.e76f29a41995cc9fc571897ef1d70551.svg";
export { ForwardRef as ReactComponent };